import { createSlice } from "@reduxjs/toolkit";

const reservationSlice = createSlice({
  name: "reservation",
  initialState: {
    reservation: [{
      courtNumber: '',
      Description: '',
      EndTime: '',
      Id: '',
      IsAllDay: '',
      IsReadonly: '',
      Player: [],
      RecurrenceRule: '',
      StartTime: '',
      Subject:''
}], 
    refresh:  false
  },
  reducers: {
    
    refreshCart: (state, action) => {
       state.refresh = action.payload;
    },
    addReservation: (state, action) => {
      state.reservation = [...state.reservation, action.payload];
      state.refresh = true;
    },
     removeReservation: (state, action) => {
      state.reservation = state.reservation.filter((item) => item.reservationId !== action.payload)
      state.refresh = true
     },
    setClearReservation: (state) => {
      state.reservation.reservationName = "";
      state.reservation.reservationCheckIn = "";
      state.reservation.reservationCheckOut = "";
      state.reservation.courtName = "";
      state.reservation.reservationBy = "";
      state.refresh = true;
    },
  
 },
});
export const { addReservation,removeReservation, setClearReservation, refreshCart } =
  reservationSlice.actions;
export default reservationSlice.reducer;